import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")
  const _component_change_display_currency_modal = _resolveComponent("change-display-currency-modal")

  return (_ctx.isCurrencySelectorVisible)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        ref: "form",
        action: _ctx.changeCurrencyUrl,
        method: "post",
        class: "gfu-currency-selector",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
      }, [
        (_ctx.isV1)
          ? (_openBlock(), _createElementBlock("input", {
              key: 0,
              type: "hidden",
              name: "returnUrl",
              value: _ctx.currentActionUrl
            }, null, 8 /* PROPS */, _hoisted_2))
          : _createCommentVNode("v-if", true),
        (_ctx.isV1)
          ? (_openBlock(), _createElementBlock("input", {
              key: 1,
              type: "hidden",
              name: "projectCurrencyID",
              value: _ctx.pendingProjectCurrencyId
            }, null, 8 /* PROPS */, _hoisted_3))
          : _createCommentVNode("v-if", true),
        (_openBlock(), _createBlock(_component_option_field, {
          key: _ctx.selectionKey,
          "model-value": _ctx.selectedCurrencyId,
          "display-name": _ctx.Resources.ProjectHome.DisplayCurrenciesLabel,
          options: $options.fieldOptions,
          placeholder: _ctx.useProjectCurrenciesLabel,
          "show-placeholder": _ctx.isV1,
          "has-transparent-bg": $props.hasTransparentBg,
          name: "display-currency-selector",
          layout: "condensed",
          class: "_mt-0",
          "onUpdate:modelValue": $options.handleCurrencyChange,
          "data-qa": "footer-currency-dropdown"
        }, {
          label: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["model-value", "display-name", "options", "placeholder", "show-placeholder", "has-transparent-bg", "onUpdate:modelValue"])),
        (!_ctx.isV1)
          ? (_openBlock(), _createBlock(_component_change_display_currency_modal, {
              key: 2,
              "is-visible": _ctx.isCurrencyModalVisible,
              currency: _ctx.pendingCurrency,
              onAccept: $setup.applyCurrency,
              onCancel: _ctx.cancelCurrency
            }, null, 8 /* PROPS */, ["is-visible", "currency", "onAccept", "onCancel"]))
          : _createCommentVNode("v-if", true)
      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}